var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1582 14.7744C8.1092 5.99446 19.9622 5.99446 23.9132 14.7744",
    stroke: "#363636",
    strokeWidth: 1.64625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0366 19.1641C13.6043 19.1641 13.1761 19.0789 12.7767 18.9135C12.3772 18.748 12.0142 18.5055 11.7085 18.1997C11.4028 17.894 11.1602 17.531 10.9948 17.1316C10.8293 16.7321 10.7441 16.304 10.7441 15.8716C10.7441 15.4392 10.8293 15.0111 10.9948 14.6116C11.1602 14.2121 11.4028 13.8492 11.7085 13.5435C12.0142 13.2377 12.3772 12.9952 12.7767 12.8297C13.1761 12.6643 13.6043 12.5791 14.0366 12.5791C14.9099 12.5791 15.7473 12.926 16.3648 13.5435C16.9822 14.1609 17.3291 14.9984 17.3291 15.8716C17.3291 16.7448 16.9822 17.5823 16.3648 18.1997C15.7473 18.8172 14.9099 19.1641 14.0366 19.1641Z",
    stroke: "#363636",
    strokeWidth: 1.64625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewEye);
export default __webpack_public_path__ + "static/media/icon-view-eye.d74fa0b226eba9cd20a16d28689df3e6.svg";
export { ForwardRef as ReactComponent };